// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This css is for background image.
While creating css class is not recommended when using tailwind,
but I guess this one is well justified because this will be a widely available background class
*/
.container-bg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/background.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;EACE,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":["/*\nThis css is for background image.\nWhile creating css class is not recommended when using tailwind,\nbut I guess this one is well justified because this will be a widely available background class\n*/\n.container-bg {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
